import React, { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Box, TextField, Typography } from "@mui/material";
import axios from "axios";
import { MdEdit } from "react-icons/md";
import { IconButton } from "@mui/material";
import { Colours } from "../assets/global/Theme-variable";
import LinkedAccounts from "./profile/LinkedAccounts";
import { getConfig } from "./profile/config";
import Spinner from "../components/Spinner/Spinner";
import RouterBreadcrumbs from "../components/Breadcrumbs";
import ImageUpload from "../components/ImageUpload";
import S3 from "react-aws-s3";
import SaveIcon from "@mui/icons-material/Save";
import { APP_URL } from "../API/apiConfig";
import {
  useLoggedInUserState,
  useLoggedInUserUpdater,
  useUserUpdater,
} from "../context/UserContext";

export default function Profile({ open, setOpenProfile }) {
  const { getAccessTokenSilently, isLoading } = useAuth0();
  const loggedInUser = useLoggedInUserState();
  const updateLoggedInUser = useLoggedInUserUpdater();
  const [disabledName, toggleDisabledName] = React.useState(true);
  const [disabledDisplayName, toggleDisabledDisplayName] = React.useState(true);
  const [disabledRole, toggleDisabledRole] = React.useState(true);

  const getUser = useUserUpdater();

  const { apiOrigin = APP_URL } = getConfig(); // using API from configuration
  const userid = loggedInUser && loggedInUser.user_id;
  const [name, setName] = useState(loggedInUser.name);
  const [nickname, setNickname] = useState(loggedInUser.nickname);
  const [role, setRole] = useState(
    loggedInUser?.user_metadata?.role || "unknown"
  );
  const [photo, setPhoto] = useState(loggedInUser?.picture);
  // const [email, setEmail] = useState(loggedInUser?.email);

  const [showIcon, setShowIcon] = useState("");

  const updateName = async (name) => {
    const token = await getAccessTokenSilently();

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const data = {
      userid: userid,
      data: { name: name },
    };

    await axios
      .post(`${apiOrigin}/api/pos/updatename`, data, config)
      .then((response) => {
        updateLoggedInUser(response.data);
        toggleDisabledName(true);
      })
      .catch((error) => {
        console.log("fe err", error);
      });
  };
  const config = {
    bucketName: process.env.REACT_APP_BUCKET_NAME,
    region: process.env.REACT_APP_REGION,
    accessKeyId: process.env.REACT_APP_ACCESS,
    secretAccessKey: process.env.REACT_APP_SECRET,
    GENERATE_SOURCEMAP: false,
  };

  const handleFileInput = (e) => {
    const ReactS3Client = new S3(config);
    const fileName = loggedInUser.user_id;
    ReactS3Client.uploadFile(e.target.files[0], fileName)
      .then((data) => {
        console.log(data);
        setPhoto(data.location);
        updatePhoto(data.location);
      })
      .catch((err) => console.log(err));
  };

  const handleFileDelete = (e) => {
    const ReactS3Client = new S3(config);
    ReactS3Client.deleteFile(loggedInUser.user_id)
      .then((data) => {
        updatePhoto(
          "https://max-cloud-images.s3-eu-west-1.amazonaws.com/place-holder.png"
        );
        setPhoto(
          "https://max-cloud-images.s3-eu-west-1.amazonaws.com/place-holder.png"
        );
      })
      .catch((err) => console.log(err));
    getUser();
  };

  const updatePhoto = async (photo) => {
    const token = await getAccessTokenSilently();
    const body = {
      userid: userid,
      data: {
        picture: photo ? photo : null,
      },
    };
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };

    await axios
      .post(`${apiOrigin}/api/pos/updateavatar`, body, config)
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.log("fe err", error);
      });
    getUser();
  };

  const updateNickname = async (displayName) => {
    const token = await getAccessTokenSilently();
    const body = {
      userid: userid,
      data: { nickname: nickname },
    };

    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };

    await axios
      .post(`${apiOrigin}/api/pos/updatedisplayname`, body, config)
      .then((response) => {
        updateLoggedInUser(response.data);
        toggleDisabledDisplayName(true);
      })
      .catch((error) => {
        console.log("fe err", error);
      });
  };
  const updateRole = async (role) => {
    const token = await getAccessTokenSilently();
    const body = {
      userid: userid,
      data: { role: role },
    };

    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };

    await axios
      .post(`${apiOrigin}/api/pos/updatemetadata`, body, config)
      .then((response) => {
        updateLoggedInUser(response.data);
        toggleDisabledRole(true);
      })
      .catch((error) => {
        console.log("fe err", error);
      });
  };

  if (isLoading) {
    return <Spinner />;
  }

  if (!loggedInUser) {
    return <Spinner />;
  }

  return (
    <Box
      sx={{
        flex: 1,
        minHeight: "100%",
        width: "100%",
        ml: 4,
        mr: 4,
        pt: 1,
      }}
    >
      <Box
        sx={{
          width: "100%",
          mb: 2,
          mt: 2,
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <RouterBreadcrumbs />
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "space-between",
          justifyContent: "space-between",
          mb: 2,
          width: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            mb: 0,
            width: "20%",
          }}
        >
          <ImageUpload
            handleFileInput={handleFileInput}
            handleFileDelete={handleFileDelete}
            item={loggedInUser}
            image={photo}
            setImage={setPhoto}
            variant="round"
          />
        </Box>
        <Box
          sx={{
            width: "80%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            gap: 1,
          }}
        >
          <Box
            sx={{
              justifyContent: "flex-start",
              display: "flex",
              flexDirection: "row",
              width: "100%",
              alignItems: "center",
              gap: 2,
            }}
            onMouseEnter={() => setShowIcon("name")}
            onMouseLeave={() => setShowIcon("")}
          >
            <Box
              sx={{ width: "30%", display: "flex", justifyContent: "flex-end" }}
            >
              <Typography variant="body1">Full Name</Typography>
            </Box>

            <TextField
              size="small"
              value={name}
              onChange={(event) => {
                setName(event.target.value);
              }}
              fullWidth
              sx={{ width: "90%" }}
              disabled={disabledName}
            />
            <Box sx={{ width: "10%" }}>
              <IconButton
                aria-label="edit name"
                onClick={() => toggleDisabledName(!disabledName)}
                sx={{
                  display:
                    showIcon === "name" && disabledName ? "flex" : "none",
                }}
              >
                <MdEdit size={20} color={Colours.gsblue} />
              </IconButton>
              <IconButton
                aria-label="edit name"
                onClick={() => {
                  name !== loggedInUser?.name && updateName(name);
                }}
                sx={{
                  display: !disabledName ? "flex" : "none",
                }}
              >
                <SaveIcon />
              </IconButton>
            </Box>
          </Box>
          <Box
            sx={{
              justifyContent: "flex-start",
              display: "flex",
              flexDirection: "row",
              width: "100%",
              alignItems: "center",
              gap: 2,
            }}
            onMouseEnter={() => setShowIcon("displayname")}
            onMouseLeave={() => setShowIcon("")}
          >
            <Box
              sx={{ width: "30%", display: "flex", justifyContent: "flex-end" }}
            >
              <Typography>Display Name</Typography>
            </Box>
            <TextField
              size="small"
              fullWidth
              sx={{ width: "90%" }}
              value={nickname}
              onChange={(event) => {
                setNickname(event.target.value);
              }}
              disabled={disabledDisplayName}
            />
            <Box sx={{ width: "10%" }}>
              <IconButton
                aria-label="edit name"
                onClick={() => toggleDisabledDisplayName(!disabledDisplayName)}
                sx={{
                  display:
                    showIcon === "displayname" && disabledDisplayName
                      ? "flex"
                      : "none",
                }}
              >
                <MdEdit size={20} color={Colours.gsblue} />
              </IconButton>
              <IconButton
                aria-label="edit name"
                onClick={() => {
                  nickname !== loggedInUser?.nickname &&
                    updateNickname(nickname);
                }}
                sx={{
                  display: !disabledDisplayName ? "flex" : "none",
                }}
              >
                <SaveIcon />
              </IconButton>
            </Box>
          </Box>

          <Box
            sx={{
              justifyContent: "flex-start",
              display: "flex",
              flexDirection: "row",
              width: "100%",
              alignItems: "center",
              gap: 2,
            }}
            onMouseEnter={() => setShowIcon("role")}
            onMouseLeave={() => setShowIcon("")}
          >
            <Box
              sx={{ width: "30%", display: "flex", justifyContent: "flex-end" }}
            >
              <Typography>Role</Typography>
            </Box>
            <TextField
              size="small"
              onChange={(event) => {
                setRole(event.target.value);
              }}
              sx={{ width: "90%" }}
              value={role}
              disabled={disabledRole}
              fullWidth
            />
            <Box sx={{ width: "10%" }}>
              <IconButton
                aria-label="edit role"
                onClick={() => toggleDisabledRole(!disabledRole)}
                sx={{
                  display:
                    showIcon === "role" && disabledRole ? "flex" : "none",
                }}
              >
                <MdEdit size={20} color={Colours.gsblue} />
              </IconButton>
              <IconButton
                aria-label="edit name"
                onClick={() => {
                  disabledRole !== loggedInUser?.role && updateRole(role);
                }}
                sx={{
                  display: !disabledRole ? "flex" : "none",
                }}
              >
                <SaveIcon />
              </IconButton>
            </Box>
          </Box>
          <Box
            sx={{
              width: "100%",
              justifyContent: "flex-start",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 2,
            }}
          >
            <Box
              sx={{ width: "30%", display: "flex", justifyContent: "flex-end" }}
            >
              <Typography>Email Address</Typography>
            </Box>
            <TextField
              size="small"
              sx={{ width: "90%" }}
              fullWidth
              value={loggedInUser?.email}
              disabled
            />
            <Box sx={{ width: "10%" }}></Box>
          </Box>
        </Box>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
        <LinkedAccounts loggedInUser={loggedInUser} />
      </Box>
    </Box>
  );
}
